<template>
  <div>
    <!-- <van-nav-bar
      title="获得证书"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <van-form @submit="submit" class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          label="证书名称"
          placeholder="请输入证书名称"
          v-model="certificate.certName"
          required
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          input-align="right"
          readonly
          label="获得时间"
          @click="selectbirth = true"
          is-link
          :value="certificate.certGetTime"
          placeholder="请选择获得证书时间"
          required
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
      </van-cell-group>
      <div class="fixed-bottom">
        <van-button
          v-if="$route.query.id"
          type="primary"
          class="btn-org-border"
          color="#FFF9F9"
          round
          @click="del($route.query.id)"
          >删 除</van-button
        >
        <van-button
          type="primary"
          class="btn-blue"
          color="linear-gradient(to right top, #2F72F6,#1C54CF)"
          round
          native-type="submit"
          >保 存</van-button
        >
      </div>
    </van-form>
    <!--选择生日-->
    <van-popup v-model="selectbirth" position="bottom" style="width: 100%;">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择时间"
        @cancel="selectbirth = false"
        @confirm="onConfirmBirth"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "basicInfo",
  data() {
    return {
      id: this.$route.query.id,
      certificate: {},
      selectbirth: false,
      minDate: new Date(1979, 0, 1),
      maxDate: new Date(),
      currentDate: new Date()
    };
  },
  methods: {
    moment,
    onload(id) {
      this.module.api.certDetail({
        params: { id },
        success: res => {
          res.certGetTime = moment(res.certGetTime).format("YYYY-MM-DD");
          this.certificate = res;
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    onConfirmBirth() {
      this.certificate.certGetTime = moment(this.currentDate).format(
        "YYYY-MM-DD"
      );
      this.selectbirth = false;
    },
    submit() {
      this.module.api.certSubmit({
        params: Object.assign({}, this.certificate, {
          certGetTime: moment(this.certificate.certGetTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }),
        success: res => {
          this.toast("保存成功");
          this.onClickLeft();
        }
      });
    },
    del(id) {
      this.module.api.certDelete({
        params: { id },
        success: res => {
          this.toast("删除成功");
          this.onClickLeft();
        }
      });
    }
  },
  mounted() {
    this.id && this.onload(this.id);
  }
};
</script>

<style lang="less" scoped>
.user-img {
  position: relative;
  width: 88px;
  margin: 20px auto 40px;
  img {
    width: 88px;
    height: 88px;
  }
  i {
    position: absolute;
    right: 0;
    top: 0;
    color: #2f72f6;
    font-size: 22px;
  }
}
/deep/.van-cell {
  padding: 20px 16px;
}
/deep/.van-hairline--top-bottom::after,
/deep/.van-hairline-unset--top-bottom::after {
  display: none;
}
/deep/.van-cell__right-icon {
  transform: rotate(90deg);
  top: -4px;
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 1;
  }
  .btn-org-border {
    border: 1px solid #ff5945 !important;
    box-shadow: none;
    margin-right: 16px;
    flex: 1;
    color: #ff5945;
    .van-button__text {
      color: #ff5945;
    }
  }
}
</style>
